import { ValidationResult, ValidatorOptions } from '.';
import { RequiredValidator } from './required.validator';
import { Validator } from './validator';

export class LengthValidator extends Validator {
    public validate(value: string, options: ValidatorOptions) {
        const { maxLength, minLength } = options;

        if (!value) {
            return new RequiredValidator().validate(value, options);
        }
        if (maxLength && (value?.length ?? 0) > maxLength) {
            return new ValidationResult(
                false,
                `Please enter a value no longer than ${maxLength} characters`
            );
        }
        if (minLength && (value?.length ?? minLength) < minLength) {
            return new ValidationResult(
                false,
                `Please enter a value no shorter than ${minLength} characters`
            );
        }

        return new ValidationResult(true);
    }
}
